// Notification sound hook for chat page
import { useRef, useEffect, useCallback } from 'react';
import {
    playNotificationSound as playSound,
    notifyNewMessage,
    testNotification,
    playBrowserNotificationSound
} from '@/utils/notificationUtils';
import { requestGlobalNotificationPermission } from '@/utils/globalNotificationManager';

interface UseNotificationSoundReturn {
    playNotificationSound: (message?: string, sender?: string) => void;
    testNotificationSound: () => void;
    isEnabled: boolean;
    toggleNotification: () => void;
    requestNotificationPermission: () => Promise<NotificationPermission>;
}

export const useNotificationSound = (): UseNotificationSoundReturn => {
    const isEnabledRef = useRef(true);

    // 注意：现在无论窗口是否可见都会播放提示音

    // Hook 初始化 - 可以在这里做一些初始化工作
    useEffect(() => {
        // 可以在这里预加载音频或做其他初始化
    }, []);

    // 播放提示音的函数
    const playNotificationSound = useCallback(async (message?: string, sender?: string) => {
        // 只要启用通知就播放提示音，无论窗口是否可见
        if (isEnabledRef.current) {
            if (message && sender) {
                // 如果有消息内容，使用综合通知函数
                await notifyNewMessage(message, sender);
            } else {
                // 只播放声音
                await playSound();
            }
        }
    }, []);

    // 测试提示音（忽略窗口可见性状态）
    const testNotificationSound = useCallback(async () => {
        if (isEnabledRef.current) {
            await testNotification();
        }
    }, []);

    // 切换通知开关
    const toggleNotification = useCallback(() => {
        isEnabledRef.current = !isEnabledRef.current;
        console.log('通知提示音:', isEnabledRef.current ? '已启用' : '已禁用');
    }, []);

    return {
        playNotificationSound,
        testNotificationSound,
        isEnabled: isEnabledRef.current,
        toggleNotification,
        requestNotificationPermission: requestGlobalNotificationPermission,
    };
};
